import { TypedUser } from "interface/user.model";
import { TypedTripManifest } from "./trip_manifest.query";
import queryClient, { IQueryParams } from ".";
import helpers from "helpers/index";
import axios from "axios";
import { useMutation, useQuery } from "@tanstack/react-query";
import { TypedTransactions } from "./transactions.query";

/**
 *   Interface/model file auto generate for Driver_settlement
 *   Interface for back-end
 *   Model for front-end.
 *   They are the same!
 */
export interface DriverSettlementOrderSnapshotItem {
    customer_information?: string;
    total_fee?: number;
    pickup_address?: string;
    pickup_note?: string;
    total_must_pay?: number;
    dropoff_address?: string;
    dropoff_note?: string;
    order_fee?: {
        fee_value?: number;
        fee_description?: string;
    }[]
    payment_information?: TypedTransactions[]
}

export type DriverSettlementOrderSnapshot = Record<string, DriverSettlementOrderSnapshotItem>;

export type DriverSettlementFeeSnapshotItem = Record<string, number>;

export type DriverSettlementOrderFeeSnapshot = Record<string, DriverSettlementFeeSnapshotItem>;

export interface TypedDriver_settlement {
    id?: string;
    driver_id?: string;
    vehicle_id?: string;
    journey_id?: string;


    trip_manifest_id?: string;
    trip_name?: string;
    license_plate?: string;
    trip_departure_date?: string;
    total_seats?: number;
    total_goods?: number;
    total_fare?: number;
    total_fee?: number;
    total_due?: number;
    total_settlement_amount?: number;
    driver_earning_amount?: number;
    money_collected_by?: bigint;
    money_collected_at?: string;
    driver_settlement_status?: string; // enum('OPEN', 'CLOSED') 
    createdAt?: string;


    order_snapshot?: DriverSettlementOrderSnapshot;
    order_fee_snapshot?: DriverSettlementOrderFeeSnapshot;
    trip_manifest_fee_snapshot?: DriverSettlementFeeSnapshotItem;


    /** Nơi lưu trữ thông tin lương và thưởng ... */
    driver_earning_snapshot?: any;


    /** Bảng nối */
    driver_data?: TypedUser; // bảng nối với user
    money_collector?: TypedUser; // bảng nối với user
    trip_manifest?: TypedTripManifest; // bảng nối với trip_manifest

}



type IQuery = TypedDriver_settlement & IQueryParams;




/*
* List of all driver settlements
*/
export function useGetDriver_settlements(object: IQuery) {
    const EndURL = helpers.buildEndUrl(object);
    return useQuery({
        queryKey: ["driver_settlement/fetch_entity_list", object],
        queryFn: () => axios.get<{
            data: TypedDriver_settlement[], analytics: {
                "total": {
                    "count": number,
                    "amount": number
                },
                "open": {
                    "count": number,
                    "amount": number
                },
                "closed": {
                    "count": number,
                    "amount": number
                }

            }
        }>(`/driver_settlement/${EndURL}`).then(response => {
            let { data, headers } = response;
            const { data: driverSettlements, analytics } = data;
            return {
                body: driverSettlements,
                totalItems: Number(headers['x-total-count'] || 0),
                analytics
            }
        }),
    });
}



/** Xem chi tiết một driver settlement */
export function useGetDriverSettlement(id: string) {
    return useQuery({
        queryKey: ["driver_settlement/fetch_entity", id],
        queryFn: () => axios.get<TypedDriver_settlement>(`/driver_settlement/${id}`).then(response => response.data),
    });

}

/** Tải về excel bản đang xem */
export function useDownloadCurrentDriverSettlement() {
    return useMutation({
        mutationKey: ["driver_settlement/download"],
        mutationFn: (object) => axios.get<Blob>(`/driver_settlement/download${helpers.buildEndUrl(object)}`, { responseType: 'blob', }).then(response => response.data),
    })
}



/** Hiển thị tại trang chủ, hiển thị trực quan theo ngày thôi ... */
export function useGetDriver_settlementAnalytics() {
    return useQuery({
        queryKey: ["driver_settlement/general_analytics"],
        queryFn: () => axios.get<{
            total_settlements: number;
            total_open_settlements: number;
            total_closed_settlements: number;
        }>(`/driver_settlement/general_analytics`).then(response => response.data),
    });
}

/** Hiển thị widget trang chủ */
export function useGetDriver_settlementDailyreport() {
    return useQuery({
        queryKey: ["driver_settlement/daily_report_widget"],
        queryFn: () => axios.get<{
            user_id: string,
            display_name: string,
            total_trip_manifest: number,
            total_amount: number
        }[]>(`/driver_settlement/daily_report_widget`).then(response => response.data),
    });
}



/** Đánh dấu là đã thu tiền  */
export function useMutateDriverSettlementMarkAsClose() {
    return useMutation({
        mutationKey: ['driver_settlement/mark_as_close'],
        mutationFn: (driver_settlement_id: string) => axios.patch<any>(`/driver_settlement/mark_as_close/${driver_settlement_id}`).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['driver_settlement/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['driver_settlement/fetch_entity'] });
            queryClient.invalidateQueries({ queryKey: ['driver_settlement/general_analytics'] });
        }
    });
}

/** Đánh dấu lại là chưa thu tiền ... */
export function useMutateDriverSettlementMarkAsOpen() {
    return useMutation({
        mutationKey: ['driver_settlement/mark_as_open'],
        mutationFn: (driver_settlement_id: string) => axios.patch<any>(`/driver_settlement/mark_as_open/${driver_settlement_id}`).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['driver_settlement/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['driver_settlement/fetch_entity'] });
            queryClient.invalidateQueries({ queryKey: ['driver_settlement/general_analytics'] });
        }
    });
}
/** Xóa bỏ record ... */
export function useMutateDriverSettlementDelete() {
    return useMutation({
        mutationKey: ['driver_settlement/delete'],
        mutationFn: (driver_settlement_id: string) => axios.delete<any>(`/driver_settlement/${driver_settlement_id}`).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['driver_settlement/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['driver_settlement/fetch_entity'] });
            queryClient.invalidateQueries({ queryKey: ['driver_settlement/general_analytics'] });
            queryClient.invalidateQueries({ queryKey: ['trip_manifest/fetch_entity'] });
            queryClient.invalidateQueries({ queryKey: ['trip/fetch_entity_list'] });

        }
    });
}

/** 
 * Tạo record từ trip_manifest_id
 * Thường thì là tự động, nhưng có nhiều trường hợp không tự động được, nên cần có nút bấm để tạo record này.
 */

export function useMutateCreateDriverSettlement() {
    return useMutation({
        mutationKey: ['driver_settlement/create_entity'],
        mutationFn: (trip_manifest_id: any) => axios.post<any>(`/driver_settlement`, { trip_manifest_id }).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['trip_manifest/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['trip_manifest/fetch_entity_list_for_list'] });
            queryClient.invalidateQueries({ queryKey: ['trip/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['trip_manifest/fetch_entity'] });

            queryClient.invalidateQueries({ queryKey: ['trip_manifest/driver_visualization'] });

            // queryClient.invalidateQueries({ queryKey: ['driver_settlement/general_analytics'] });
        }
    });
}
